import React, { Component } from "react"
import classNames from "classnames"

import Swiper from 'swiper/dist/js/swiper.js'

const SWIPER_CONFIG = {
  slideClass: 'item',
  slideActiveClass: 'active',
  slideDuplicatedActiveClass: 'duplicate-active',
  slideVisibleClass: 'visible',
  slideDuplicateClass: 'duplicate',
  slideNextClass: 'next',
  slideDuplicatedNextClass: 'duplicate-next',
  slidePrevClass: 'prev',
  slideDuplicatedPrevClass: 'duplicate-prev',
  wrapperClass: 'content',
  slidesPerView: 'auto',
  pagination: {
    el: '.paginator',
    clickable: true,
    bulletClass: 'page',
    bulletActiveClass: 'active',
    clickableClass: 'clickable',
    renderBullet: (index, className) => `<span class="${className}"></span>`
  },
  loop: true
}

export class ContentList extends Component {

  swiper = null
  
  componentDidMount() {
    this.swiper = new Swiper('.content-list', SWIPER_CONFIG)
  }

  render() {
    const { children, className, ...otherProps } = this.props

    return (
      <div className={classNames("content-list", className)} {...otherProps}>
        <div className="content">
          {children.map((item, index) => (
            <div key={index} className="item">
              {item}
            </div>
          ))}
        </div>

        <div className="paginator" />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/ui/elements/ContentList.js